import { render } from "./RightDrawerComp.vue?vue&type=template&id=a51930dc&scoped=true"
import script from "./RightDrawerComp.vue?vue&type=script&lang=js"
export * from "./RightDrawerComp.vue?vue&type=script&lang=js"

import "./RightDrawerComp.vue?vue&type=style&index=0&id=a51930dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a51930dc"]])

export default __exports__